<template>
    <div class="o-guide-steps guide-steps">
        <div 
            class="guide-steps__container"
            ref="stepsContainer"
        >
            <button
                :id="`path-step-${index}`"
                v-for="(step, index) in path"
                :key="index"
                class="guide-steps__step"
                :class="{'guide-steps__step--active': index === localValue, 'guide-steps__step--scroll': isScroll }"
                type="button"
                @click="changeCurrentStep(index)"
            >
                <span
                    class="guide-steps__index"
                    :class="{'guide-steps__index--start': index === 0}"
                >
                    {{ index + 1 }}
                </span>
                <span class="guide-steps__icon-container">                            
                    <svg-icon
                        v-if="index === path.length - 1 && index === localValue"
                        original
                        name="navigation/marker-white"
                        class="guide-steps__icon"
                    />
                    <svg-icon
                        v-else-if="index === path.length - 1"
                        original
                        name="navigation/marker"
                        class="guide-steps__icon"
                    />
                    <svg-icon
                        v-else-if="index === localValue"
                        original
                        :name="`navigation/${step.direction}-white`"
                        class="guide-steps__icon"
                    />
                    <svg-icon
                        v-else
                        original
                        :name="`navigation/${step.direction}`"
                        class="guide-steps__icon"
                    />
                </span>
                <span class="guide-steps__wrapper">
                    <OStepText
                        class="guide-steps__text"
                        :step="step"
                    />
                    <span class="guide-steps__distance">
                        {{ step.distance }}  {{ $t('o-guide-steps') }}
                    </span>
                </span>
                <svg-icon
                    orignal
                    name="icons/arrow-right"
                    class="guide-steps__arrow"
                />
            </button>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import OStepText from '../../unique-organisms/o-step-text/o-step-text';

import {
    UI_STEP_SELECTED,
    MAP_SHOW_PATH_STEPS
} from "../../../shared/components/map-viewer/constants/map-events";

export default {
    name: 'OGuideSteps',
    components: {
        OStepText
    },
    data() {
        return {
            isScroll: false
        }
    },
    props: {
        value: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapState({
            path: state => state.activePath?.steps
        }),
        ...mapGetters([
            't'
        ]),
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    mounted() {
        this.initEventListeners();
    },
    updated() {
        this.checkScroll();
        // this.alignStepsHeightCss();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        initEventListeners() {
            this.$bus.$on(UI_STEP_SELECTED, this.changeCurrentStep);
        },
        deactivateEventsListeners() {
            this.$bus.$off(UI_STEP_SELECTED, this.changeCurrentStep);
        },
        changeCurrentStep(index) {
            this.localValue = index;
            this.$bus.$emit(MAP_SHOW_PATH_STEPS, index);
            this.$store.commit('setActiveStepIndex', index);
            document.getElementById(`path-step-${index}`).scrollIntoView({ behavior: 'smooth', block: 'center'});
        },
        alignStepsHeightCss() {
            const arr = [...document.getElementsByClassName('guide-steps__step')];
            const values = [];

            arr.forEach(item => {
                values.push(parseInt(item.offsetHeight));
            });

            arr.forEach(item => {
                item.style.height = Math.max(...values) + 'px';
            });
        },
        checkScroll() {
            this.isScroll = this.$refs.stepsContainer.scrollHeight > this.$refs.stepsContainer.clientHeight;
        }
    }
}
</script>

<style lang="scss">
@import "o-guide-steps";
</style>
